import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import {  } from "../actions/api"
import {  } from "../actions/localStates"
import { formatDate } from '../actions/helpers'

class RemovedActiveKeysView extends Component {
	constructor() {
		super();
		this.state = {

		};

	}

	componentDidMount() {

	}

	componentWillUnmount () {

	}

	closeInfoPopup () {
		this.setState({
	        showCertificateInfo: !this.state.showCertificateInfo
	    });
	}


	render() {
		return (
			<div>
				{
					this.props.tokenList.tokenEnquire && this.props.tokenList.tokenEnquire.tokenContentDescriptorCached !== null
					? <div style={{marginTop: "10px"}}>
						{
							Object.keys(this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys).length === 0 && this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.constructor === Object
							? null
							: <div>
								<label>{i18next.t("activeKeys")}</label>
								{
									this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT !== undefined
									? <div style={{paddingLeft: "0px", paddingRight: "0px", marginBottom: "10px"}} className="table-border bg-color-active row col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "left"}} className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
											<div className="table-header">
												<label>{i18next.t("owner")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label>
													{
														this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].subject.commonName
													}
												</label>
												<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
													{
														i18next.t("drfou")
													}
													{
														this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].extensions.drfou
													}
												</label>
												<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
													{
														i18next.t("edrpou")
													}
													{
														this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].extensions.edrpou
													}
												</label>
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
											<div className="table-header">
												<label>{i18next.t("appointment")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<div>
													<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
														{
															this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT] !== undefined && this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].extensions.keyUsage.indexOf("KEY_AGREEMENT") > -1
															? i18next.t("KEY_AGREEMENT")
															: i18next.t("DIGITAL_SIGNATURE")
														}
													</label>
												</div>
												<div>
													<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
														{
															this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT] !== undefined && this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].extensions.isElectronicStamp === true
															? i18next.t("electronicStamp")
															: null
														}
													</label>
												</div>
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
											<div className="table-header">
												<label>{i18next.t("key")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<div>
													<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
														{
															i18next.t("algorithm")
														}
														{
															this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].subjectPublicKeyInfo.algorithm === "1.2.840.10045.2.1" ? i18next.t("ECDSA-256") : (this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].subjectPublicKeyInfo.algorithm === "1.2.840.113549.1.1.1" ? i18next.t("RSA") : this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].subjectPublicKeyInfo.algorithm)
														}
													</label>
												</div>
												<div>
													<label className="row col-12" style={{textAlign: "left", paddingLeft: "0px", paddingRight: "0px", marginBottom: "0px"}}>
														{
															i18next.t("identifire")
														}
													</label>
													<div style={{wordWrap: "break-word", fontSize: "12px", textAlign: "left"}}>
														{
															this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT
														}
													</div>
												</div>
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<div className="table-header">
												<label>{i18next.t("certificate")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<div>
													<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
														{
															i18next.t("notBefore")
														}
														{
															this.props.actions.formatDate(this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].notBefore)
														}
													</label>
												</div>
												<div>
													<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
														{
															i18next.t("notAfter")
														}
														{
															this.props.actions.formatDate(this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].notAfter)
														}
													</label>
												</div>
												<div>
													<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
														{
															i18next.t("issuer")
														}
														{
															this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.AGREEMENT].issuer.commonName
														}
													</label>
												</div>
											</div>
										</div>
									</div>
									: null
								}
								{
									this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE !== undefined
									? <div style={{paddingLeft: "0px", paddingRight: "0px"}} className="table-border bg-color-active row col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "left"}} className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
											<div className="table-header">
												<label>{i18next.t("owner")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label>
													{
														this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].subject.commonName
													}
												</label>
												<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
													{
														i18next.t("drfou")
													}
													{
														this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].extensions.drfou
													}
												</label>
												<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
													{
														i18next.t("edrpou")
													}
													{
														this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].extensions.edrpou
													}
												</label>
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
											<div className="table-header">
												<label>{i18next.t("appointment")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
													{
														this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE] !== undefined && this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].extensions.keyUsage.indexOf("DIGITAL_SIGNATURE") > -1
														? i18next.t("DIGITAL_SIGNATURE")
														: i18next.t("KEY_AGREEMENT")
													}
												</label>
												<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
													{
														this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE] !== undefined && this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].extensions.isElectronicStamp === true
														? i18next.t("electronicStamp")
														: null
													}
												</label>
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
											<div className="table-header">
												<label>{i18next.t("key")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<div>
													<div>
														<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
															{
																i18next.t("algorithm")
															}
															{
																this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].subjectPublicKeyInfo.algorithm === "1.2.840.10045.2.1" ? i18next.t("ECDSA-256") : (this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].subjectPublicKeyInfo.algorithm === "1.2.840.113549.1.1.1" ? i18next.t("RSA") : this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].subjectPublicKeyInfo.algorithm)
															}
														</label>
													</div>
													<div>
														<label className="row col-12" style={{textAlign: "left", paddingLeft: "0px", paddingRight: "0px", marginBottom: "0px"}}>
															{
																i18next.t("identifire")
															}
														</label>
														<div style={{wordWrap: "break-word", fontSize: "12px", textAlign: "left"}}>
															{
																this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE
															}
														</div>
													</div>
												</div>
											</div>
										</div>
										<div style={{paddingLeft: "0px", paddingRight: "0px", textAlign: "center"}} className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<div className="table-header">
												<label>{i18next.t("certificate")}</label>
											</div>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
												<div>
													<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
														{
															i18next.t("notBefore")
														}
														{
															this.props.actions.formatDate(this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].notBefore)
														}
													</label>
												</div>
												<div>
													<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
														{
															i18next.t("notAfter")
														}
														{
															this.props.actions.formatDate(this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].notAfter)
														}
													</label>
												</div>
												<div>
													<label className="col-12" style={{textAlign: "left", paddingLeft: "0px", marginBottom: "0px"}}>
														{
															i18next.t("issuer")
														}
														{
															this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.certificateInfos[this.props.tokenList.tokenEnquire.tokenContentDescriptorCached.activeKeys.SIGNATURE].issuer.commonName
														}
													</label>
												</div>
											</div>
										</div>
									</div>
									: null
								}
							</div>
						}
					</div>
					: null
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        login: state.loginReducer,
        tokenList: state.removedTokenListReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	formatDate
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RemovedActiveKeysView);